import { useExperimentFlag } from './useExperimentFlag';

export const useExperimentCheckoutSignatureAuth = (): boolean =>
    !useExperimentFlag('enable_checkout_binding_auth', 'exp');
